// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

const specialRequestItemUrl = "/api/ksc/specialRequestItem";
const priceRangesSpecialRequestItemUrl = `${specialRequestItemUrl}/priceranges`;

export interface SpecialRequestItemsFormApiParameter extends ApiParameter {
    priceRange?: string;
    qtyNeeded?: string;
    upcNumber?: string;
    modelNumber?: string;
    partNumber?: string;
    manufacturerItem?: string;
    description?: string;
    comments?: string;
}

export function submitSpecialRequestItemsForm(parameter: SpecialRequestItemsFormApiParameter) {
    return post<SpecialRequestItemsFormApiParameter>(`${specialRequestItemUrl}`, parameter);
}

export function getPriceRangesSpecialRequestItemUrl() {
    return get<string>(`${priceRangesSpecialRequestItemUrl}`);
}
